/* unplugin-vue-components disabled */

export default {
  props: {
    sources: {
      type: Array,
      required: true
    },
    showText: {
      type: Boolean,
      default: true
    },
    viewCount: {
      type: Number,
      default: 4
    }
  },
  computed: {
    source_view() {
      return this.sources.slice(0, this.viewCount)
    },
    text(){
      return $utils.str.pluralize(this.sources.length, 'source')
    }
  }
}
